(function() {
  exports.Emitter = require('./emitter');

  exports.Disposable = require('./disposable');

  exports.CompositeDisposable = require('./composite-disposable');

}).call(this);



/*****************
 ** WEBPACK FOOTER
 ** ./~/event-kit/lib/event-kit.js
 ** module id = 3
 ** module chunks = 0
 **/